var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"page"},[_c('div',[_c('h2',[_vm._v("Using GIFs")]),_c('ol',[_c('li',[_vm._v("Open any individual chat or group.")]),_c('li',[_vm._v("In the text input field, tap "),_c('strong',[_vm._v("GIF")]),_vm._v(".")]),_c('li',[_vm._v("Choose a GIF. Then tap "),_c('strong',[_vm._v("Send")]),_vm._v(".")])])])])])
}]

export { render, staticRenderFns }